import { render } from "./TaskTable.vue?vue&type=template&id=28bfefd8&scoped=true"
import script from "./TaskTable.vue?vue&type=script&lang=js"
export * from "./TaskTable.vue?vue&type=script&lang=js"

import "./TaskTable.vue?vue&type=style&index=0&id=28bfefd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28bfefd8"]])

export default __exports__